import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Verdane',
    description: 'Verdane brings every account into one calm place, with a personal AI advisor for budgeting, investing and planning, and certified advisors for the big decisions.',
    url: getOrigin(),
    ogImage: 'https://verdane.cdn.modulify.website/brand/share-image.jpg'
}
